module.exports = __webpack_public_path__ + "img/full0-min.7497d1c8.png";